import RequestedProductSize from 'src/app/model/product/requested-product-size';
import { ClientStickerPartInstance } from 'src/app/model/product/windowsticker/client-sticker-part';
import StandardStickerPart from 'src/app/model/product/windowsticker/standard-sticker-part';
import StickerPart from 'src/app/model/product/windowsticker/sticker-part';

export class ClientWindowStickerPartFormHelper {
  private constructor() {}

  static readonly STICKER_PART_TYPE_CHOICES = {
    STANDARD_STICKER_PART: {
      label: `Raamsticker 'standaardafmetingen'`,
      initializer: () => {
        const toReturn = new StandardStickerPart();
        toReturn.requestedProductSize = new RequestedProductSize();
        return toReturn;
      }
    },
    CUSTOM_STICKER_PART: {
      label: `Raamsticker 'op maat'`,
      initializer: () => new StickerPart()
    }
  };

  static readonly STICKER_PART_TYPE_CHOICES_ARRAY: StickerPartTypeChoice[] = Object.values(
    ClientWindowStickerPartFormHelper.STICKER_PART_TYPE_CHOICES
  );
}

export interface StickerPartTypeChoice {
  label: string;
  initializer: () => ClientStickerPartInstance;
}
